<script>
import { constants } from '@src/constants'

export default {
  props: {
    group: {
      type: Number,
      default: 0,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    noGutters: {
      type: Boolean,
      default: false,
    },
    cols: {
      type: Number,
      default: 3,
    },
  },
  data() {
    return {
      selectedTab: null,
      selectedCard: [],
      tabs: [
        { id: 0, value: 'Show all' },
        { id: 1, value: 'Medical History' },
        { id: 2, value: 'Medication' },
        { id: 3, value: 'Diagnostic' },
      ],
      menuItems: constants.healthRecord,
    }
  },
  computed: {
    menuItemsFiltered() {
      const show = Object.values(this.menuItems).filter((el) => {
        if (el.model_name === 'symptomcheaker') {
          return false
        }
        return el.show_menu
      })

      if (this.selectedTab) {
        return show.filter((el) => {
          return el.group === this.selectedTab
        })
      } else {
        return show
      }
    },
  },
  watch: {
    group(newValue, oldValue) {
      this.selectedTab = newValue
    },
  },
  mounted() {
    this.selectedTab = this.group
  },
  methods: {
    selectEvent() {
      this.$emit('select-changed', this.selectedCard)
    },
    selectAll() {
      this.selectedCard = this.menuItemsFiltered
      this.selectEvent()
    },
    unselectAll() {
      this.selectedCard = []
      this.selectEvent()
    },
  },
}
</script>

<template>
  <div>
    <!-- group tabs -->
    <v-item-group v-model="selectedTab" mandatory>
      <v-row class="px-10 mt-7" no-gutters>
        <v-item
          v-for="tab in tabs"
          :key="tab.id"
          v-slot="{ active, toggle }"
          :value="tab.id"
        >
          <span
            class="clickable mr-4"
            :class="
              active
                ? 'primary--text' + ' ' + $style.tab
                : 'label--text' + ' ' + $style.tab
            "
            @click="toggle"
            >{{ tab.value }}</span
          >
        </v-item>
      </v-row>
    </v-item-group>

    <!-- select all / deselect all -->

    <v-row v-if="multiple" class="px-10" no-gutters>
      <span
        class="clickable mr-4"
        :class="'primary--text' + ' ' + $style.tab"
        @click="selectAll"
        >Select All</span
      >
      <span
        class="clickable mr-4"
        :class="'primary--text' + ' ' + $style.tab"
        @click="unselectAll"
        >Unselect All</span
      >
    </v-row>

    <!-- hr cards -->
    <v-item-group
      v-model="selectedCard"
      :multiple="multiple"
      class="mb-10"
      @change="selectEvent"
    >
      <v-container :class="noGutters ? '' : $style.cardsContainer">
        <v-row justify="center">
          <v-col
            v-for="item in menuItemsFiltered"
            :key="item.value"
            class="d-flex justify-center"
            cols="12"
            sm="auto"
          >
            <v-item v-slot="{ active, toggle }" :value="item">
              <v-sheet
                class="clickable"
                :class="$style.hrCard"
                :style="{
                  background: item.background || '#f7f7fc',
                }"
                width="156"
                height="160"
                flat
                @click="toggle"
              >
                <v-card-text>
                  <v-container fluid class="pa-0">
                    <v-row class="mb-4" justify="center" no-gutters>
                      <v-sheet
                        rounded="sm"
                        width="70"
                        height="70"
                        class="d-flex justify-center align-center mt-1"
                        color="rgba(255, 255, 255, 0.3)"
                      >
                        <v-icon v-show="!active" color="offwhite" large>
                          mdi-{{ item.icon }}
                        </v-icon>
                        <v-icon v-show="active" color="offwhite" large>
                          mdi-check
                        </v-icon>
                      </v-sheet>
                    </v-row>
                    <v-row
                      :class="$style.cardText"
                      justify="center"
                      class="offwhite--text noselect"
                      no-gutters
                    >
                      {{ $t(item.menu_title) }}</v-row
                    >
                  </v-container>
                </v-card-text>
              </v-sheet>
            </v-item>
          </v-col>
        </v-row>
      </v-container>
    </v-item-group>
  </div>
</template>

<style lang="scss" module>
@import '@design';
.menuTab :hover {
  color: white;
  background: $color-theme-light-primary;
  border-radius: 24px;
}

.tab {
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.25px;
}

.cardsContainer {
  padding-right: 120px !important;
  padding-left: 120px !important;
}

@media screen and (max-width: 960px) {
  .cardsContainer {
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
}

.hrCard {
  border-radius: 16px !important;
}

.activeCard {
  border: 1px solid $color-theme-light-secondary !important;
}

.cardText {
  font-size: 14px;
  font-weight: 700;
  text-align: center;
  letter-spacing: 0.75px;
}
</style>
